import React from "react";
import RangeSlider from "../components/modernized/RangeSlider";
import themePropTypes from "../theme/theme-prop-types";
import calculatePadding from "../utils/padding-utils";

const ModernizedRangeSlider = ({ field, appData }) => {
  const {
    name,
    label,
    disabled,
    min,
    max,
    i18n_min_label,
    i18n_max_label,
    i18n_handle_labels,
    default_values, // the name is plural, but this is a single integer value
    step
  } = field;

  const { handleChange } = appData;
  const changeHandler = newValue => {
    handleChange({
      [name]: newValue
    });
  };

  const padding = calculatePadding(field);

  return (
    <div style={padding} className='ModernizedRangeSlider-wrapper-web-sdk'>
      <RangeSlider
        name={name}
        label={label}
        disabled={disabled}
        min={min}
        max={max}
        i18nMinLabel={i18n_min_label}
        i18nMaxLabel={i18n_max_label}
        i18nHandleLabels={i18n_handle_labels}
        defaultValue={default_values}
        step={step}
        onChange={changeHandler}
      />
    </div>
  );
};

ModernizedRangeSlider.propTypes = themePropTypes.modernizedRangeSlider;

export default ModernizedRangeSlider;
